import { render, staticRenderFns } from "./Festival.vue?vue&type=template&id=c5f62390&scoped=true&"
import script from "./Festival.vue?vue&type=script&lang=js&"
export * from "./Festival.vue?vue&type=script&lang=js&"
import style0 from "./Festival.vue?vue&type=style&index=0&id=c5f62390&prod&lang=scss&scoped=true&"
import style1 from "./Festival.vue?vue&type=style&index=1&id=c5f62390&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5f62390",
  null
  
)

export default component.exports